import { render } from "./formLonja.vue?vue&type=template&id=928cae84&scoped=true"
import script from "./formLonja.vue?vue&type=script&lang=js"
export * from "./formLonja.vue?vue&type=script&lang=js"

import "./formLonja.vue?vue&type=style&index=0&id=928cae84&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928cae84"]])

export default __exports__